import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import NSFLogo from "../../assets/images/nsf_logo.png";
import UCBLogo from "../../assets/images/UCBerkeley.png"
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";
import Logo from "../../assets/images/wui-go_icon_transparent.png"; // adjust the path if needed
import "./LandingPage.css"
import {
    getFirestore,
    collection,
    addDoc,
    serverTimestamp
  } from "firebase/firestore";


export default function LandingPage() {
    const storage = getStorage();
    const db = getFirestore();

    const [teamPhotos, setTeamPhotos] = useState({
        Sarah: null,
        Kenichi: null,
        Tony: null,
    });

    const [email, setEmail] = useState("");
    const [signUpStatus, setSignUpStatus] = useState("");

    useEffect(() => {
        const names = ["Sarah", "Kenichi", "Tony"];
        names.forEach((name) => {
        const imgRef = storageRef(storage, `team/${name}.png`);
        getDownloadURL(imgRef)
            .then((url) => {
            setTeamPhotos((prev) => ({
                ...prev,
                [name]: url,
            }));
            })
            .catch((err) => {
            console.error("failed to load", name, err);
            });
        });
    }, [storage]);


    const handleSignUp = async (e) => {
        e.preventDefault();
        setSignUpStatus("Submitting...");
        try {
          await addDoc(
            collection(db, "signups"),
            {
              email:      email.trim(),
              createdAt:  serverTimestamp()
            }
          );
          setSignUpStatus("Thanks for signing up!");
          setEmail("");
        } catch (err) {
          console.error("Firestore error:", err);
          setSignUpStatus("Error submitting—please try again.");
        }
      };

  return (
    <div className="antialiased text-gray-900">

        <header className="SiteHeader">
        <div className="SiteHeader__inner">
            <div className="SiteHeader__logo">
            <img src={Logo} alt="WUI-Go" />
            </div>
            <nav className="SiteHeader__nav">
            {//<a href="#product" className="SiteHeader__link">Product</a>
            //<a href="#team"    className="SiteHeader__link">Team</a>
                }
            </nav>
        </div>
        </header>


      {/* ====== Hero ====== */}
      <section className="Hero">
            {/* the diagonal gradient background */}
            <div className="Hero__slice" />

            <div className="Hero__inner">
                <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="Hero__content"
                >
                <h1 className="Hero__title">
                    Bridge the gap between residents and government on disaster evacuation
                </h1>
                <p className="Hero__subtitle">
                    Sign up to receive early access and updates 
                </p>
                <form
                className="Hero__form"
                onSubmit={handleSignUp}
                >
                    <input
                        type="email"
                        placeholder="Email address"
                        className="Hero__input"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                    />
                    <button
                        type="submit"
                        className="Hero__button"
                    >
                        Sign up now
                    </button>
                </form>

                {signUpStatus && (
                <p className="mt-2 text-sm text-gray-700">
                    {signUpStatus}
                </p>
                )}
                </motion.div>
            </div>
        </section>

        

        {/* ====== Modular Feature Section #2 ====== */}
      <section
        className="Copy HomepageFrontdoor__copyHero variant--Hero"
        style={{ "--paddingRight": "var(--columnPaddingLarge)",
          "--section-vertical-padding": "1rem" 
         }}
      >
        <header className="Copy__header">
          <h2 className="Copy__caption">Traffic Modeling</h2>
          <h1 className="Copy__title">
          Simulate and Validate Evacuation Scenarios 
          </h1>
        </header>
        <div className="Copy__body">
          <p>
            Leverage our traffic models developed at UC Berkeley to simulate and validate 
            disaster evacuation scenarios. 
          </p>
        </div>
      </section>

      <section className="VideoSection">
        <div className="VideoSection__embed">
        <iframe
          src="https://www.youtube-nocookie.com/embed/rwtevAfDW3I"
          title="WUI-Go Planning AI"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    </section>

      {/* ====== Modular Feature Section #1 ====== */}
      <section
        className="Copy HomepageFrontdoor__copyHero variant--Hero"
        style={{ "--paddingRight": "var(--columnPaddingLarge)" }}
      >
        <header className="Copy__header">
          <h2 className="Copy__caption">Disaster Preparedness</h2>
          <h1 className="Copy__title">
            Personalized disaster evacuation preparedness
          </h1>
        </header>
        <div className="Copy__body">
          <p>
            Provide disaster preparedness information tailored to resident needs
            such as routes, to-do lists, best practices, and more.
          </p>
        </div>
      </section>

      {/* ====== Modular Feature Section #2 ====== */}
      <section
        className="Copy HomepageFrontdoor__copyHero variant--Hero"
        style={{ "--paddingRight": "var(--columnPaddingLarge)",
          "--section-vertical-padding": "1rem" 
         }}
      >
        <header className="Copy__header">
          <h2 className="Copy__caption">Public outreach</h2>
          <h1 className="Copy__title">
            Customizable content formats for outreach
          </h1>
        </header>
        <div className="Copy__body">
          <p>
            Provide content to residents customized to their needs, such as
            language, visual/audio and technology needs to maximize reach.
          </p>
        </div>
      </section>

      <section className="VideoSection">
        <div className="VideoSection__embed">
            <iframe
              src="https://www.youtube-nocookie.com/embed/WbJ4OrFpr38"
              title="WUI-Go public-facing podcasts"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
        </div>
      </section>


      {/* ====== Modular Feature Section #2 ====== */}
      <section
        className="Copy HomepageFrontdoor__copyHero variant--Hero"
        style={{ "--paddingRight": "var(--columnPaddingLarge)" }}
      >
        <header className="Copy__header">
          <h2 className="Copy__caption">AI Planning Assistant</h2>
          <h1 className="Copy__title">
            Leverage our AI for analyzing evacuation scenarios
          </h1>
        </header>
        <div className="Copy__body">
          <p>
            Leverage our AI Planning Assistant to run quick analysis on disaster evacuation models, such as top risky areas, congested routes, scenario comparison, etc.
          </p>
        </div>
      </section>

      {/* ====== Modular Feature Section #2 ====== */}
      <section
        className="Copy HomepageFrontdoor__copyHero variant--Hero"
        style={{ "--paddingRight": "var(--columnPaddingLarge)" }}
      >
        <header className="Copy__header">
          <h2 className="Copy__caption">Realtime Evacuation</h2>
          <h1 className="Copy__title">
            Leverage our traffic models for realtime evacuation 
          </h1>
        </header>
        <div className="Copy__body">
          <p>
            Once we earn your trust through our planning solutions, we can proceed to solve the problem of helping residents evacuate quickly and safely in realtime.
          </p>
        </div>
      </section>


      

      {/* ====== Team Section ====== */}
        <section className="Team">
        <div className="Team__inner">
            <header className="Team__header">
            <h2 className="Team__title">Our Team</h2>
            <p className="Team__subtitle"></p>
            </header>

            {/* future grid of team members */}
            <div className="Team__grid">
                {[
                { name: "Sarah", displayName: "Dr Sarah Lindbergh", title: "CEO and Principal Investigator" },
                { name: "Kenichi", displayName: "Dr Kenichi Soga", title: "Scientific advisor" },
                { name: "Tony", displayName: "Tony Alex", title: "Industry Liaison" },
                ].map((member) => (
                <div key={member.name} className="Team__member">
                    <img
                    src={teamPhotos[member.name]}
                    alt={member.name}
                    className="Team__photo"
                    />
                    <h3 className="Team__name">{member.displayName}</h3>
                    <p className="Team__role">{member.title}</p>
                </div>
                ))}
            </div>
        </div>
        </section>

        <section className="Sponsor">
          <div className="Sponsor__inner">
            <h3 className="Sponsor__caption">Backed by</h3>

            <div className="Sponsor__flex">
              <img src={NSFLogo} alt="National Science Foundation" className="Sponsor__logo"/>

              <p className="Sponsor__copy">
                This project is funded by the National Science Foundation (NSF) –
                Small Business Innovation Research (SBIR) Grant Program.
              </p>
            </div>

            <div className="Sponsor__flex">
              <img src={UCBLogo} alt="UC Berkeley" className="Sponsor__logo"/>

              <p className="Sponsor__copy">
                This project is a spinoff from the Soga Research group at UC Berkeley.
              </p>
            </div>
          </div>
      </section>

        {/* ====== Footer ====== */}
        <footer className="Footer">
        <div className="Footer__inner">
            © {new Date().getFullYear()} WUI-Go. All rights reserved.
        </div>
        </footer>

    </div>
  );
}